import React from 'react';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
import { SvgIcon } from 'core/icons';
import { combineClassNames } from 'core/css';

function calculateCssPositioningBasedOnContainers() {
  const isAtLeastLarge = MediaQuery.atLeast('large');
  const content = document.getElementById('contentView');
  const offsetTop = parseInt(content.style.marginTop, 10) - 10;

  if (!isAtLeastLarge) {
    return {
      top: offsetTop,
      bottom: 73,
      left: 0,
      right: 0
    };
  }

  const detail = document.getElementById('byo-detail-content');
  const detailRect = detail.getBoundingClientRect();
  const offsetLeft = detailRect.left + 10;
  const offsetRight = detailRect.right;
  const width = offsetRight - offsetLeft;

  return {
    top: offsetTop,
    bottom: 0,
    left: offsetLeft,
    width: width
  };
}

const OptionsLoadingOverlay = ({ isLoading }) => {
  if (!isLoading) {
    return null;
  }
  return (
    <div
      className={combineClassNames([
        'options-loading-overlay',
        isLoading ? 'options-loading-overlay--visible' : ''
      ])}
      style={calculateCssPositioningBasedOnContainers()}>
      <SvgIcon name="spinner" className="options-loading-overlay__spinner" />
    </div>
  );
};

export default OptionsLoadingOverlay;
